import {
  BreakpointsEnum,
  SVG,
  isBreakpointDown,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import Amex from 'assets/PaymentCardTypes/amex.svg';
import Discover from 'assets/PaymentCardTypes/discover.svg';
import Generic from 'assets/PaymentCardTypes/generic.svg';
import Mastercard from 'assets/PaymentCardTypes/mastercard.svg';
import Visa from 'assets/PaymentCardTypes/visa.svg';
import {Text, View} from 'native-base';
import React from 'react';

export const enum CreditCardType {
  mastercard = 'MASTERCARD',
  visa = 'VISA',
  amex = 'AMERICAN EXPRESS',
  discover = 'DISCOVER',
  generic = 'GENERIC',
}

export interface PaymentCardPropsTypes {
  cardNickname?: string;
  cardNumber: string | undefined;
  cardType: CreditCardType;
  hideName?: boolean;
}

const getCardType = (c: CreditCardType) => {
  switch (c) {
    case CreditCardType.mastercard:
      return {
        card: Mastercard,
        nameColor: 'white',
        numberColor: 'silverSand',
      };
    case CreditCardType.visa:
      return {
        card: Visa,
        nameColor: 'tuna',
        numberColor: 'ghostWhite',
      };
    case CreditCardType.discover:
      return {
        card: Discover,
        nameColor: 'infoLight',
        numberColor: 'infoLight',
      };
    case CreditCardType.amex:
      return {
        card: Amex,
        nameColor: 'white',
        numberColor: 'white',
      };
    default:
      return {
        card: Generic,
        nameColor: 'white',
        numberColor: 'white',
      };
  }
};

const PaymentCard: React.FC<PaymentCardPropsTypes> = ({
  cardNickname,
  cardNumber,
  cardType,
  hideName = false,
}) => {
  const {card, nameColor, numberColor} = getCardType(cardType);

  const parseName = name => {
    if (name.charAt(name.length - 1) === 's') {
      name += '’';
    } else {
      name += '’s';
    }
    return name;
  };

  const isNano = isBreakpointDown(useBreakpoint(), BreakpointsEnum.NANO);
  const isLongName = cardNickname && cardNickname.length > 16;
  const shouldResize = isNano && isLongName;

  return (
    <View
      maxH="175px"
      maxWidth="269px"
      borderRadius="16px"
      /*
        The following shadows are specific to these cards and are not in the theme.
      */
      style={{
        shadowOffset: {width: 5, height: 5},
        shadowOpacity: 0.25,
        shadowRadius: 10,
        elevation: 8,
      }}>
      <SVG source={card} style={{maxWidth: '269px'}} />
      {hideName ? null : (
        <Text
          numberOfLines={1}
          position="absolute"
          bottom="35%"
          maxWidth="90%"
          left={shouldResize ? '1.5%' : '6%'}
          fontSize={shouldResize ? '16px' : '18px'}
          fontFamily="heading"
          fontWeight="semibold"
          lineHeight="20px"
          color={nameColor}>
          {cardNickname || 'My Saved Card'}
        </Text>
      )}
      <Text
        position="absolute"
        bottom="7%"
        left={isNano ? '3%' : '6%'}
        fontSize="14px"
        color={numberColor}
        lineHeight="19px"
        fontFamily="body"
        width="119px">
        {'•••• •••• •••• ' + (cardNumber || '••••')}
      </Text>
    </View>
  );
};

export default PaymentCard;
